import {TieredOrActive} from "../dispatch/tieredOrActive.tsx";
import {SortOrder} from "../rpc/webrpc-client.gen.ts";
import {objectFromEntries} from "../util/arutil.tsx";
import {iconForEntityType} from "../fa.tsx";
import {z} from "zod/v4";

export const InspectionSettings = z.object({
    order: TieredOrActive,
    sortOrder: SortOrder,
});
export type InspectionSettings = z.infer<typeof InspectionSettings>;
export const defaultInspectionSettings: InspectionSettings = {
    order: TieredOrActive.enum.active,
    sortOrder: SortOrder.enum.DESC,
};

export function validateInspectionSettings(raw: Record<string, unknown>): InspectionSettings {
    const zprv = InspectionSettings.safeParse(raw);
    const rv = zprv.success ? zprv.data : defaultInspectionSettings;
    return rv;
}

const inspectorFacets = ["bundle", "waste"] as const;
const rawInspectorFacetEnum = z.enum(inspectorFacets);
export type InspectorFacet = keyof typeof rawInspectorFacetEnum.enum;
export const InspectorFacet = rawInspectorFacetEnum.default("waste");
export const inspectorFacetIcons = objectFromEntries(inspectorFacets.map(name => {
    const entry = [name, iconForEntityType(name).icon] as const;
    return entry;
}));


